import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../../../shared/ui/src/components/buttons/iconButton';

/*
 * Props.
 */

interface CreateContactInformationFieldActionsProps {
  className?: string;
  isFirst: boolean;
  isLast: boolean;
  hasValue: boolean;
  addAnotherLabel: ReactNode;

  onAdd: Handler;
  onRemove: Handler;
}

/*
 * Style.
 */

const StyledActionsWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 4px;
  height: 26px;

  &:empty {
    display: none;
  }
`;

const StyledIconButton = styled(IconButton)`
  margin-top: 2px;
`;

const StyledTooltipWrapperDiv = styled.div`
  white-space: nowrap;
`;

/*
 * Component.
 */

export const CreateContactInformationFieldActions: FC<CreateContactInformationFieldActionsProps> = (
  props,
) => {
  const {className, isFirst, isLast, hasValue, addAnotherLabel, onAdd, onRemove} = props;

  return (
    <StyledActionsWrapperDiv className={className}>
      {!isFirst && (
        <StyledIconButton
          iconName="trashSmall"
          onClick={(event) => {
            event.preventDefault();
            onRemove();
          }}
          label={<Trans id="create-contact-form-actions-remove-button">Remove</Trans>}
        />
      )}
      {hasValue && isLast && (
        <StyledIconButton
          iconName="plusCircleSmall"
          onClick={(event) => {
            event.preventDefault();
            onAdd();
          }}
          label={<StyledTooltipWrapperDiv>{addAnotherLabel}</StyledTooltipWrapperDiv>}
        />
      )}
    </StyledActionsWrapperDiv>
  );
};
